var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#efa7a7;}.b{clip-path:url(#a);}.c{fill:#00a9e7;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(1670 25)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1670 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.753,4.355A3.437,3.437,0,0,0,2.7,7.389c0,2.369,1.764,4.629,3.7,6.371a24.046,24.046,0,0,0,2.617,2.031c.357.241.654.427.861.553l.011.007.011-.007c.207-.126.5-.312.861-.553a24.038,24.038,0,0,0,2.616-2.031c1.936-1.742,3.7-4,3.7-6.371a3.438,3.438,0,0,0-6.611-1.322.625.625,0,0,1-1.154,0A3.438,3.438,0,0,0,7.753,4.355ZM9.887,17.076l-.306.545h0l-.005,0-.019-.011-.07-.04c-.06-.035-.148-.087-.258-.154-.221-.134-.534-.331-.909-.584a25.288,25.288,0,0,1-2.755-2.139c-1.971-1.774-4.113-4.357-4.113-7.3A4.688,4.688,0,0,1,9.887,4.576a4.688,4.688,0,0,1,8.438,2.813c0,2.944-2.142,5.527-4.113,7.3a25.286,25.286,0,0,1-2.754,2.139c-.375.253-.689.449-.909.584-.11.067-.2.119-.258.154l-.07.04-.019.011-.005,0h0S10.193,17.622,9.887,17.076Zm0,0,.305.545a.626.626,0,0,1-.611,0Z",
    transform: "translate(1670.113 24.799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.1144df15eb92e6300afe9133b61e5bb2.svg";
export { ForwardRef as ReactComponent };